module.exports = __webpack_public_path__ + "static/media/gt.656c9899.svg";